import * as React from "react";
import {
  Route,
  RouterProvider,
  Routes,
  createBrowserRouter,
} from "react-router-dom";
import { AuthGuard } from "./components/AuthGuard";

import Login from "./containers/Login";
import Register from "./containers/Register";
import Dashboard from "./containers/Dashboard";
import Home from "./containers/Dashboard/Home";
import Users from "./containers/Dashboard/Users";
import PatientDetail from "./containers/Dashboard/Patient/Detail";
import PatientAnalytics from "./containers/Dashboard/Patient/Analytics";
import TestMigrate from './containers/Dashboard/Migrate';
import Prescription from "./containers/Dashboard/Prescription";
import NotFound from "./containers/NotFound";
import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";
import ForgotPassword from "./containers/ForgotPassword";
import Organizations from "./containers/Dashboard/Organizations";
import Organization from "./containers/Dashboard/Organization";
import SetPassword from "./containers/SetPassword";
import SignUpTicket from "./containers/SignUpTicket";

const routes = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <Dashboard />
      </AuthGuard>
    ),
    children: [
      {
        path: "test-migrate",
        element: (
          <AuthGuard>
            <TestMigrate />
          </AuthGuard>
        ),
      },
      {
        path: "users/", // RxGames admin page
        element: (
          <AuthGuard>
            <Users />
          </AuthGuard>
        ),
      },
      {
        path: "clients/:id/prescriptions/new",
        element: (
          <AuthGuard>
            <Prescription />
          </AuthGuard>
        ),
      },
      {
        path: "clients/:id/prescriptions/:prescriptionId/edit",
        element: (
          <AuthGuard>
            <Prescription />
          </AuthGuard>
        ),
      },
      {
        path: "clients/:id",
        element: (
          <AuthGuard>
            <PatientDetail />
          </AuthGuard>
        ),
      },
      {
        path: "clients/:id/analytics",
        element: (
          <AuthGuard>
            <PatientAnalytics />
          </AuthGuard>
        ),
      },
      {
        path: "/organizations", // RxGames admin page
        element: (
          <AuthGuard>
            <Organizations />
          </AuthGuard>
        ),
      },
      {
        path: "/organization",  // Org admin page
        element: (
          <AuthGuard>
            <Organization />
          </AuthGuard>
        ),
      },
      {
        path: "/",
        // index:true,
        element: (
          <AuthGuard>
            <Home />
          </AuthGuard>
        ),
      },
    ],
  },
  {
    path: "/login/sso-callback",
    element: <AuthenticateWithRedirectCallback />,
  },
  {
    path: "/login/*",
    element: <Login />,
  },
  {
    path: "/register/*",
    element: <Register />,
  },
  {
    path: "/forgot-password/*",
    element: <ForgotPassword />,
  },
  {
    path: "/welcome",
    element: (
      <AuthGuard>
        <SetPassword />
      </AuthGuard>
    ),
  },
  {
    path: "/sign-up-ticket",
    element: (
      <SignUpTicket />
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];


function AppRoutes() {
  return (
    <Routes>
      {routes.map((route) => (
        <Route path={route.path} element={route.element}>
          {route.children &&
            route.children.map((childRoute) => (
              <Route path={childRoute.path} element={childRoute.element} />
            ))}
        </Route>
      ))}
    </Routes>
  );
}

export default AppRoutes;
